import { useState, useCallback } from "react";
import { DataGrid } from "@mui/x-data-grid";
import usePersistedState from "@hooks/usePersistedState";
import type { GridRowsProp, GridColDef, GridRowParams, GridSortModel } from "@mui/x-data-grid";

import { tableStyle } from "./styles";

export const Table = ({
  rows,
  columns,
  initialState = {},
  isRowLink,
  onRowClick,
  storageId,
}: {
  rows: GridRowsProp<any>;
  columns: GridColDef<any>[];
  initialState?: any;
  isRowLink?: boolean;
  onRowClick?: (params: GridRowParams<any>) => void;
  storageId?: string;
}) => {
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 100, // Maximum number of rows per page for free plan
    page: 0,
  });

  const { state: storedParams, setState: setStoredParams } = usePersistedState(storageId ?? "default", {}, "session");

  const handleSortModelChange = useCallback((sortingModel: GridSortModel) => {
    const { field, sort } = sortingModel?.[0] || {};
    const sorting = {
      sortModel: [{ field, sort }],
    };

    setStoredParams((prev: any) => ({ ...prev, sorting }));
  }, []);

  return (
    <div className={isRowLink ? "data-grid--row-as-link" : ""}>
      <DataGrid
        sx={tableStyle}
        rows={rows}
        columns={columns}
        initialState={{
          ...initialState,
          ...storedParams,
          pagination: { paginationModel },
        }}
        sortingOrder={["asc", "desc"]}
        onPaginationModelChange={setPaginationModel}
        onSortModelChange={handleSortModelChange}
        onRowClick={onRowClick}
        disableColumnFilter
        disableColumnResize
        disableColumnMenu
        hideFooter
      />
    </div>
  );
};
